import { render, staticRenderFns } from "./AsociarMensajesForm2.vue?vue&type=template&id=2a2e2ca4&scoped=true&"
import script from "./AsociarMensajesForm2.vue?vue&type=script&lang=ts&"
export * from "./AsociarMensajesForm2.vue?vue&type=script&lang=ts&"
import style0 from "./AsociarMensajesForm2.vue?vue&type=style&index=0&id=2a2e2ca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2e2ca4",
  null
  
)

export default component.exports